import { EnumTypeValue } from "@/shared/types";

export const Functie = {
    Machinist: "MCN",
    Hoofdconducteur: "HC",
    WachtdientOpvangPersoneel: "WOP",
    WachtdientOpvangReizigers: "WOR",
    MedewerkerOpLocatie: "MOL",
    VrijwilligerOpStation: "VOS",
} as const;

export type Functie = EnumTypeValue<typeof Functie>;

export const CONTACTPERSONEN_QUERY_KEY = "contactpersonen";
